import { Badge } from "@/shared/components/common/Badge";
import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";
import type { ComponentProps } from "react";

type TagVariant = ComponentProps<typeof Badge>["variant"];

export type RoomCardTagType = {
  status: "active" | "inactive";
  title: string;
  variant: TagVariant;
  icon: ComponentProps<typeof PhosphorIcon>["name"];
};

interface RoomCardTagProps {
  tag: RoomCardTagType;
}

export default function RoomCardTag({ tag }: RoomCardTagProps) {
  return (
    <Badge
      // variant={tag.variant}
      variant={"outline"}
    >
      <Flex alignItems={"center"} gap={"2"}>
        <PhosphorIcon
          name={tag.icon}
          size={18}
          weight="bold"
          className="text-muted-foreground"
        />
        <Typography variant={"caption"} className="text-muted-foreground/90">
          {tag.title}
        </Typography>
      </Flex>
    </Badge>
  );
}
